import { MapContainer, TileLayer, Polygon, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const TOWNS = [
  { name: "Liverpool", coords: [53.4084, -2.9916] },
  { name: "Manchester", coords: [53.4808, -2.2426] },
  { name: "Wigan", coords: [53.545, -2.6318] },
  { name: "Warrington", coords: [53.39, -2.597] },
  { name: "St Helens", coords: [53.4534, -2.7362] },
  { name: "Chester", coords: [53.1934, -2.8931] },
  { name: "Chorley", coords: [53.6538, -2.632] },
  { name: "Runcorn", coords: [53.3417, -2.7315] },
  { name: "Wirral", coords: [53.3727, -3.0738] },
  { name: "Southport", coords: [53.6458, -3.0103] },
  { name: "Ellesmere Port", coords: [53.2793, -2.8974] },
  { name: "Widnes", coords: [53.363, -2.729] },
  { name: "Skelmersdale", coords: [53.5507, -2.7743] },
  { name: "Flint", coords: [53.2497, -3.133] },
  { name: "Rhyl", coords: [53.321, -3.489] },
  { name: "Mold", coords: [53.1667, -3.1436] },
  { name: "Deeside", coords: [53.22, -3.04] },
  { name: "Preston", coords: [53.7632, -2.7031] },
  { name: "Blackburn", coords: [53.7486, -2.482] },
  { name: "Burnley", coords: [53.7893, -2.248] },
  { name: "Oldham", coords: [53.5409, -2.1114] },
  { name: "Glossop", coords: [53.4433, -1.949] },
  { name: "Crewe", coords: [53.0998, -2.4426] },
  { name: "Wrexham", coords: [53.0428, -2.9925] },
  { name: "Colwyn Bay", coords: [53.2932, -3.7276] },
];

// Approximate coverage boundary (clockwise) enclosing the covered towns
const COVERAGE_ZONE = [
  [53.86, -2.95],
  [53.83, -2.15],
  [53.48, -1.82],
  [53.05, -2.3],
  [52.98, -3.05],
  [53.15, -3.95],
  [53.55, -3.45],
  [53.8, -3.1],
];

const ACCENT = "#1E3F2D";

const ServiceAreaMap = () => {
  return (
    <div className="service-area-map" data-testid="service-area-map">
      <MapContainer
        center={[53.42, -2.85]}
        zoom={8}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%", background: "#F2F3F0" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        <Polygon
          positions={COVERAGE_ZONE}
          pathOptions={{ color: ACCENT, weight: 2, fillColor: ACCENT, fillOpacity: 0.18 }}
        />
        {TOWNS.map((town) => (
          <CircleMarker
            key={town.name}
            center={town.coords}
            radius={7}
            pathOptions={{ color: "#ffffff", weight: 2, fillColor: ACCENT, fillOpacity: 1 }}
          >
            <Tooltip direction="top" offset={[0, -6]} opacity={1}>
              {town.name}
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
};

export default ServiceAreaMap;
